import axios from "axios";
import { useEffect, useState } from "react";
import { FaDownload } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUserPlus } from "react-icons/fa";

export default function AssignJobsTable() {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [sortable, setSortable] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [goToPage, setGoToPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [pincodes, setPincodes] = useState([]);
  const [selectedPincode, setSelectedPincode] = useState("");
  const [pdf, setPdf] = useState(null);
  const [orderStatus, setOrderStatus] = useState("");

  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("Pending");
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState("");

  const { pageNo, serviceId, name } = useParams();
  const navigate = useNavigate(null);

  useEffect(() => {
    setCurrentPage(parseInt(pageNo) || 1);
    setGoToPage(parseInt(pageNo) || 1);
    getOrders();
    getPincodes();
    getDrivers();
  }, []);

  useEffect(() => {
    getOrders();
  }, [
    currentPage,
    searchTerm,
    recordsPerPage,
    sortable,
    sortOrder,
    serviceId,
    selectedPincode,
    orderStatus
  ]);

  const STATUS_LIST = [
    "Pending",
    "ACCEPTED",
    "REJECTED",
    "Shipped",
    "Delivered",
    "Cancelled",
    "Cancellation_Requested",
    "ORDER_PICKED",
    "PICKED_UP_FROM_USER",
    "ORDER_DROPPED_WAREHOUSE",
    "REASSIGNED_FOR_DELIVERY",
    "REACHED_WAREHOUSE",
    "ORDER_PICKUP",
  ];

  const handleTableSort = (column) => {
    let order = "asc";
    // Toggle sortOrder if the same column is clicked
    if (column === sortable) {
      order = sortOrder === "asc" ? "desc" : "asc";
    }
    setSortable(column);
    setSortOrder(order);
  };

  const handlePrevious = () => {
    navigate(
      `/admin-panel/assigning-job/${name}/${serviceId}/${currentPage - 1}`
    );
    setCurrentPage(currentPage - 1);
    setGoToPage(currentPage - 1);
  };

  const handleNext = () => {
    navigate(
      `/admin-panel/assigning-job/${name}/${serviceId}/${currentPage + 1}`
    );
    setCurrentPage(currentPage + 1);
    setGoToPage(currentPage + 1);
  };

  const handleGoToPage = (page) => {
    if (!page) {
      navigate(`/admin-panel/assigning-job/${name}/${serviceId}/${goToPage}`);
    } else {
      navigate(`/admin-panel/assigning-job/${name}/${serviceId}/${page}`);
      setCurrentPage(page);
    }
    setGoToPage(page);
  };

  const downloadBase64PDF = (base64Data, filename) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Fetching Data
  const getOrders = async () => {
    setLoading(true);

    console.log(
      "Fetching orders for pincode:",
      selectedPincode,
      "serviceId:",
      serviceId
    );

    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      if (currentPage < 1) {
        setCurrentPage(1);
        setGoToPage(1);
        setSearchTerm("");
        toast.error("Page number should be greater than or equal to 1");
        return;
      }

      console.log(
        "URL",
        `${process.env.REACT_APP_API_BASE_URL}/order/assign-jobs/${serviceId}?status=Active&pincode=${selectedPincode}&page=${currentPage}&search=${searchTerm}&status=${orderStatus}&limit=${recordsPerPage}&sort=${sortable}&sortOrder=${sortOrder} + "wefew"`
      );

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/order/assign-jobs/${serviceId}?pincode=${selectedPincode}&page=${currentPage}&search=${searchTerm}&status=${orderStatus}&limit=${recordsPerPage}&sort=${sortable}&sortOrder=${sortOrder}&wantPdf=true`,
        {
          headers: headers,
        }
      );

      console.log("Response", response);

      if (response.data.statusCode === 200) {
        setData(response.data.result.orders);
        setPdf(response.data.result.pdf);
        setTotalRecords(response.data.result.totalRecords);
        setCurrentPage(response.data.result.currentPage);
        setTotalPages(response.data.result.totalPages);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getPincodes = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/pincode/get-paginated-pincodes?status=Active&page=1&limit=1000&sort=${sortable}`,
        {
          headers: headers,
        }
      );
      if (response.data.statusCode === 200) {
        setPincodes(response.data.result.pincodes);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getDrivers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/view-all-drivers?verificationStatus=Approved&categoryId=${serviceId}&page=1&limit=1000`,
        {
          headers: headers,
        }
      );
      if (response.data.statusCode === 200) {
        setDrivers(response.data.result.users);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleStatusUpdate = async (status) => {
    try {
      setLoading(true);
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("orderId", selectedOrderId);

      if (selectedDriver != '') {
        formdata.append("driverId", selectedDriver);
        formdata.append("status", "ACCEPTED");
      } else {
        formdata.append("status", status);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/order/update-status`,
        formdata,
        { headers }
      );

      if (response.data.statusCode === 200) {
        toast.success(response.data.message);
        getOrders();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update status. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div>
      {/* Active Orders */}
      <ToastContainer />
      <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
        <div className="flex justify-between items-center">
          <h2 className="md:text-xl text-base font-medium">Recent Orders</h2>
          <div className="flex justify-center gap-4">
            <div className="flex items-center">
              <input
                type="text"
                className="h-[40px] md:w-[250px] w-[180px] rounded-xl border-2 border-gray-300 px-3 text-sm !outline-none"
                placeholder="Search By Order ID"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <select
                className="border text-sm h-8 outline-none w-[200px] mx-3"
                value={orderStatus}
                onChange={(e) => setOrderStatus(e.target.value)}
              >
                <option value="">All Status</option>
                {STATUS_LIST.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>


              {/* <label htmlFor="pincode" className="text-sm">Pin Code</label> <br /> */}
              {pdf && (
                <button
                  onClick={() => downloadBase64PDF(pdf, "orders.pdf")}
                  className="bg-[#c04c4c] text-white px-2 py-2 rounded-md text-sm mr-2"
                >
                  <FaDownload size={14} color="white" />
                </button>
              )}
              <select
                className="border text-sm h-8 outline-none w-[150px]"
                value={selectedPincode}
                onChange={(e) => {
                  setSelectedPincode(e.target.value);
                }}
              >
                <option value="">Select Pincode</option>
                {pincodes.map((pincode) => {
                  return (
                    <option className="border" value={pincode?.number}>
                      {pincode.number}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="md:flex flex-col relative -top-1 hidden">
              <span className="text-xs mb-0.5">Per Page</span>
              <select
                name="perPage"
                id="perPage"
                className="border border-[grey] rounded-md h-[22px] text-sm !outline-none"
                value={recordsPerPage}
                onChange={(e) => setRecordsPerPage(e.target.value)}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
              </select>
            </div>
            <div className="md:flex flex-col relative -top-1 hidden">
              <span className="text-xs mb-0.5">Go to</span>
              <input
                type="number"
                className="border border-[grey] rounded-md w-[50px] text-xs h-[22px] px-1 !outline-none"
                value={goToPage}
                onChange={(e) => {
                  handleGoToPage(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-4 justify-between flex-wrap mt-10 overflow-auto text-sm">
          <table className="w-full text-center">
            <thead>
              <tr className="border-b">

                <td className="font-medium py-4 cursor-pointer">Order Id </td>

                <td className="font-medium py-4 cursor-pointer">Family Id </td>

                <td className="font-medium py-4 cursor-pointer">
                  Customer Name{" "}
                </td>
                <td className="font-medium py-4 cursor-pointer">
                  Contact Number{" "}
                </td>
                {!name?.toLowerCase().includes("tiffin") ? (
                  <>


                    <td className="font-medium py-4 cursor-pointer">
                      Address{" "}
                    </td>
                    <td className="font-medium py-4 cursor-pointer">
                      Pin Code{" "}
                    </td>

                    <td className="font-medium py-4 cursor-pointer">
                      Product Name{" "}
                    </td>

                    <td className="font-medium py-4 cursor-pointer">
                      Quantity{" "}
                    </td>

                  </>
                ) : (
                  <>
                    <td className="font-medium py-4 cursor-pointer">
                      Pickup Address{" "}
                    </td>
                    <td className="font-medium py-4 cursor-pointer">
                      Drop Address{" "}
                    </td>
                    <td className="font-medium py-4 cursor-pointer">
                      Start Date {" "}
                    </td>
                    <td className="font-medium py-4 cursor-pointer">
                      End Date {" "}
                    </td>
                  </>
                )}

                <td className="font-medium py-4 cursor-pointer">Order Status </td>

                <td className="font-medium py-4 cursor-pointer">Actions </td>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                data.length > 0 ? (
                  data.map((item) => (
                    <tr key={item._id} className={`border-b`}>

                      <td className="py-3 text-sm">{item?.orderId}
                        <span className="text-[8px] relative -top-2">
                          {item.isEmergency ? "🔴" : ""}
                        </span>
                      </td>

                      <td className="py-3 text-sm">
                        {item?.user?._id?.substring(0, 10)}..
                      </td>


                      <td className="py-3 text-sm">{item?.user.firstName}</td>
                      <td className="py-3 text-sm">{item?.user?.phone}</td>
                      {!name?.toLowerCase().includes("tiffin") ? (
                        <>
                          <td className="py-3 text-sm whitespace-pre-line">
                            {item?.address?.fullAddress + "\n" + item?.address?.city + "\n" + item?.address?.state}
                          </td>

                          <td className="py-3 text-sm">
                            {item?.address?.pincode}
                          </td>

                          <td className="py-3 text-sm">{item?.product?.name}</td>

                          <td className="py-3 text-sm">{item?.quantity}</td>
                        </>
                      ) : (
                        <>

                          <td className="py-3 text-sm">
                            {item?.pickupAddress?.fullAddress +
                              ", " +
                              item?.pickupAddress?.city +
                              ", " +
                              item?.pickupAddress?.state}

                            {item?.pickupAddress?.pincode}
                          </td>

                          <td className="py-3 text-sm">
                            {item?.deliveryAddress?.fullAddress +
                              ", " +
                              item?.deliveryAddress?.city +
                              ", " +
                              item?.deliveryAddress?.state}

                            ( {item?.deliveryAddress?.pincode})

                          </td>

                          <td className="py-3 text-sm">
                            {formatDate(item?.startDate)}
                          </td>
                          <td className="py-3 text-sm">
                            {formatDate(item?.endDate)}
                          </td>
                        </>
                      )}
                      {/* <td className="py-3 text-sm">{item.fullAddress}</td> */}

                      <td className="py-3 text-sm">{item?.status}</td>

                      <td className="py-3 text-sm flex justify-center gap-x-3">
                        <button
                          className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                          title="View Order"
                          onClick={() => {
                            navigate(
                              `/admin-panel/assigning-job/view/${item._id}`,
                              {
                                state: { data: item, name },
                              }
                            );
                          }}
                        >
                          <i className="fa fa-eye text-white"></i>
                        </button>

                        {
                          item?.status != 'Delivered' ?
                            (
                              <>
                                <button
                                  type="button"
                                  className="bg-blue-600 text-white w-[36px] h-[36px] rounded-full ml-2 flex items-center justify-center relative group"
                                  data-toggle="modal"
                                  data-target="#assignModal"
                                  onClick={() => {
                                    setSelectedOrderId(item._id);
                                  }}
                                >
                                  <FaUserPlus size={18} />

                                  <span className="absolute bottom-[120%] left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                    Assign Driver
                                  </span>
                                </button>
                              </>
                            ) : ""
                        }

                        {!name?.toLowerCase().includes("tiffin") && item?.status != 'Delivered' ? (
                          <>
                            <button
                              type="button"
                              className="bg-blue-600 text-white w-[36px] h-[36px] rounded-full ml-2"
                              data-toggle="modal"
                              data-target="#exampleModal"
                              onClick={() => {
                                setSelectedOrderId(item._id);
                              }}
                            >
                              <i className="fa fa-edit" />
                            </button>
                          </>) : ""}

                      </td>
                    </tr>
                  ))
                ) : (
                  <td colSpan={6} className="text-center">
                    <p className="text-center w-full mt-10">No results found</p>
                  </td>
                )
              ) : (
                <td colSpan={6} className="text-center">
                  <p className="text-center w-full mt-10">Loading ...</p>
                </td>
              )}
            </tbody>
          </table>
          <div className="flex justify-between items-center w-full mt-6">
            <div className="">
              <span className="text-[13px] text-gray-500">
                Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                {currentPage * recordsPerPage > totalRecords
                  ? totalRecords
                  : currentPage * recordsPerPage}{" "}
                out of {totalRecords}
              </span>
            </div>
            <div className="flex justify-center items-center gap-x-3">
              <button
                className="h-[32px] w-[32px] bg-[#2c2c38] rounded-md text-white text-sm"
                disabled={currentPage === 1}
                onClick={handlePrevious}
              >
                <i className="fa fa-chevron-left"></i>
              </button>
              <span className="text-[13px] text-gray-500">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="h-[32px] w-[32px] bg-[#2c2c38] rounded-md text-white text-sm"
                disabled={currentPage === totalPages}
                onClick={handleNext}
              >
                <i className="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Order Status
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <select
                className="form-control"
                onChange={(e) => setSelectedStatus(e.target.value)}
                value={selectedStatus}
              >
                <option value="Pending">Pending</option>
                <option value="Out for Delivery">Out for Delivery</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
                <option value="REASSIGNED_FOR_DELIVERY">REASSIGNED_FOR_DELIVERY</option>
              </select>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => handleStatusUpdate(selectedStatus)}
                data-dismiss="modal"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="assignModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="assignModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="assignModalLabel">
                Assign Driver
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <select
                className="form-control"
                required
                onChange={(e) => setSelectedDriver(e.target.value)}
                value={selectedDriver}
              >
                <option value="">Select</option>
                {drivers.map((driver) => {
                  return (
                    <option className="border" value={driver?._id}>
                      {driver.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => handleStatusUpdate(selectedStatus)}
                data-dismiss="modal"
              >
                Assign Driver
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
